import React from "react"
import PropTypes from "prop-types"

import BadgeAlert from '../gamification_components/BadgeAlert'
import LexicoinAlert from '../gamification_components/LexicoinAlert'

const PREVIEW_LEXICOIN = {
  id: 'preview-lexicoin',
  value: 3,
  notes: 'Thanks for completing your profile!',
}

class DashboardRewardAlerts extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      pointsNotification: [],
      badgeNotification: [],
      loaded: false,
      previewBadgeRecord: null,
    }

    this.fetchNotifications = this.fetchNotifications.bind(this)
    this.fetchPreviewBadge = this.fetchPreviewBadge.bind(this)
    this.deleteNotification = this.deleteNotification.bind(this)
    this.deleteBadgeNotification = this.deleteBadgeNotification.bind(this)
    this.handleDismissed = this.handleDismissed.bind(this)
  }

  componentDidMount() {
    if (!this.props.previewReward) {
      this.fetchNotifications()
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.refreshTrigger !== prevProps.refreshTrigger && !this.props.previewReward) {
      this.fetchNotifications()
    }

    if (prevProps.previewReward && !this.props.previewReward) {
      this.setState({ previewBadgeRecord: null })
      this.fetchNotifications()
    }

    if (
      this.props.previewReward === 'badge'
      && prevProps.previewReward !== 'badge'
      && this.props.userId
    ) {
      this.fetchPreviewBadge()
    }
  }

  fetchPreviewBadge() {
    $.ajax({
      url: '../get_profile_badges',
      dataType: 'JSON',
      type: 'POST',
      data: { user_id: this.props.userId },
      success: (data) => {
        const allBadges = JSON.parse(data.data.allBadges || '[]')
        const sample = allBadges.find((badge) => /first lex/i.test(badge.name)) || allBadges[0]

        if (!sample) {
          return
        }

        this.setState({
          previewBadgeRecord: {
            id: 'preview-badge',
            badge: {
              name: sample.name,
              body: sample.body,
              image_url: sample.image_url,
            },
          },
        })
      },
      error(xhr, status, err) {
        console.log(err)
      },
    })
  }

  fetchNotifications() {
    $.ajax({
      url: '../get_user_notifications',
      dataType: 'JSON',
      type: 'GET',
      success: (data) => {
        this.setState({
          pointsNotification: data.data.points_notification || [],
          badgeNotification: JSON.parse(data.data.badge_notification || '[]'),
          loaded: true,
        })
      },
      error(xhr, status, err) {
        console.log(err)
      },
    })
  }

  deleteNotification(id) {
    $.ajax({
      url: '../delete_notification',
      dataType: 'JSON',
      type: 'DELETE',
      data: { id },
      success: () => {
        this.fetchNotifications()
      },
      error(xhr, status, err) {
        console.log(err)
      },
    })
  }

  deleteBadgeNotification(id) {
    $.ajax({
      url: '../onboard_badge',
      dataType: 'JSON',
      type: 'POST',
      data: { id },
      success: () => {
        this.fetchNotifications()
      },
      error(xhr, status, err) {
        console.log(err)
      },
    })
  }

  handleDismissed() {
    if (this.props.onDismissed) {
      this.props.onDismissed()
    }
  }

  renderPreview() {
    const { previewReward } = this.props

    if (previewReward === 'lexicoin') {
      return (
        <LexicoinAlert
          points={PREVIEW_LEXICOIN}
          confettiLottie={this.props.confettiLottie}
          lexicoin={this.props.lexicoin}
          preview
          onClose={this.props.onPreviewClose}
        />
      )
    }

    if (previewReward === 'badge') {
      if (!this.state.previewBadgeRecord) {
        return null
      }

      return (
        <BadgeAlert
          badge={this.state.previewBadgeRecord}
          confettiLottie={this.props.confettiLottie}
          preview
          onClose={this.props.onPreviewClose}
        />
      )
    }

    return null
  }

  renderLiveAlert() {
    const { pointsNotification, badgeNotification, loaded } = this.state

    if (!loaded) {
      return null
    }

    if (pointsNotification.length > 0) {
      return (
        <LexicoinAlert
          points={pointsNotification[0]}
          confettiLottie={this.props.confettiLottie}
          lexicoin={this.props.lexicoin}
          deleteNotification={this.deleteNotification}
          onDismissed={this.handleDismissed}
        />
      )
    }

    if (badgeNotification.length > 0) {
      return (
        <BadgeAlert
          badge={badgeNotification[0]}
          confettiLottie={this.props.confettiLottie}
          deleteBadgeNotification={this.deleteBadgeNotification}
          onDismissed={this.handleDismissed}
        />
      )
    }

    return null
  }

  render() {
    if (this.props.previewReward) {
      return this.renderPreview()
    }

    return this.renderLiveAlert()
  }
}

DashboardRewardAlerts.propTypes = {
  confettiLottie: PropTypes.string,
  lexicoin: PropTypes.string.isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  previewReward: PropTypes.oneOf(['badge', 'lexicoin', null]),
  onPreviewClose: PropTypes.func,
  onDismissed: PropTypes.func,
  refreshTrigger: PropTypes.number,
}

DashboardRewardAlerts.defaultProps = {
  previewReward: null,
  refreshTrigger: 0,
}

export default DashboardRewardAlerts
